<style scoped>
    .contract-group-container{
        /*position: relative;*/
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
        /*margin-right: 5px;*/
    }
    .header{
        display: inline-block;
        vertical-align: middle;
        font-size: 24px;
    }
    .handler{
        margin-left: 10px;
    }
    .edit-container{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 20px 20px 120px 20px;
        overflow: auto;
        background: white;
        z-index: 999;
    }
    .edit-header{
        font-size: 18px;
        font-weight: bold;
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .edit-title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .fill-info{
        padding-bottom: 10px;
        border-bottom: 1px solid #dddee1;
    }
    .fill-info-title{
        /**/
    }
    .fill-info-btn{
        color: #2d8cf6;
        text-decoration: underline;
        cursor: pointer;
    }
    table{
        border-collapse:collapse;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
    }
    .payee-account-container{
        margin-top: 20px;
    }
    .payee-account-table{
        width: 100%;
        border: 1px solid #dddee1;
    }
    .payee-account-table td{
        padding: 10px;
        text-align: center;
    }
    .payee-account-col-1{
        width: 60px;
        font-size: 14px;
        font-weight: bold;
    }
    .payee-account-col-2{
        width: 70px;
    }
    .payee-account-handler{
        padding: 10px;
    }
    .edit-contract-container{
        margin-top: 20px;
    }
    .edit-contract-table{
        border: 1px solid #dddee1;
        width: 100%;
    }
    .edit-contract-table th{
        padding: 10px;
        text-align: center;
    }
    .edit-contract-table td{
        padding: 10px;
    }
    .price-line{
        white-space: nowrap;
    }
    .input-btn{
        cursor: pointer;
    }
    .input-btn:hover{
        color: #444;
    }
    .pop-tip-content{
        max-height: 200px;
    }
    .ivu-poptip{
        vertical-align: top;
    }
    .ivu-poptip .ivu-btn{
        position: relative;
        top: 1px;
    }
</style>
<template>
  <div class="contract-group-container">
    <div class="line text-center">
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="输入关键字搜索"
          @on-enter="doSearch()"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_contracts_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleContractData"
        @fail="handleContractFail"
        @finally="handleContractFinally"
      />
    </div>
    <div class="list-container">
      <Table
        size="small"
        :columns="contract_columns"
        :data="contracts"
        :no-data-text="empty_tip"
        :loading="loading"
      />
      <div class="line">
        点击左侧箭头可查看详细信息
      </div>
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <ContractEditor
      ref="editor"
      :contract_types="contract_types"
      :contract_type_hash="contract_types_hash"
      @on-update="updateContract"
    />
  </div>
</template>
<script route="/fin/contract_need_pay">
  import { formattingNumber } from '@/libs/util.js'
  import ContractUid from './components/contract_uid';
  import ContractExpand from './components/contract_expand';
  import ContractEditor from '../contract/components/contract_editor';
  import ParentContractSearch from './components/parent_contract_search';
  import UserFlowBase from '../components/flow/user_flow_base';
  import FileUploader from '../components/file/uploader';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/fin/contract_need_pay',
    /* router_info_end */
    components: { ContractUid, ContractExpand, ContractEditor, UserFlowBase, FileUploader, ParentContractSearch },
    props: ['type'],
    data() {
      return {
        get_contracts_path: Util.api.query_contract_need_pay,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          per_page: 10,
          page: 1,
          search: '',
          team_id: 0,
          company_id: 0,
          contract_type_id: 0,
          flow_node_id: 0,
          user_flow_node_status: -1,
          order: 'mid'
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        contracts: [],
        contract_columns: [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 50,
            render: (h, params) => {
              return h(ContractExpand, {
                props: {
                  id: params.row.id
                }
              })
            }
          },
          {
            title: '编号',
            key: 'uid',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h(ContractUid, {
                props: {
                  contract: row
                }
              });
            }
          },
          {
            title: '名称',
            key: 'name',
            minWidth: 160,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', row.name));
              ret.push(h('div', `[${this.contract_types_hash.getSubType(row.contract_type_id)}]`));
              if (row.bill_type === 'OutSourcing') {
                ret.push(h('div', '[委外订单]'));
              }
              return h('div', ret);
            }
          },
          {
            title: '公司-团队',
            minWidth: 80,
            render: (h, params) => {
              let company = '未设置';
              if (this.companies_hash[params.row.company_id]) {
                company = this.companies_hash[params.row.company_id].short_name;
              }
              let team = '未设置';
              if (this.teams_hash[params.row.team_id]) {
                team = this.teams_hash[params.row.team_id].name;
              }
              const ret = [];
              ret.push(h('div', {
                'class':{
                  'text-bold': true
                },
              }, company));
              ret.push(h('div', team));
              return h('div', ret);
            }
          },
          {
            title: '申请人',
            minWidth: 80,
            key: 'apply_user',
            render: (h, params) => {
              const row = params.row;
              return <CustomerName id={ row.apply_user_id } />
            }
          },
          {
            title: '对方公司',
            minWidth: 90,
            key: 'payee_company'
          },
          {
            title: '合同总价',
            align: 'right',
            minWidth: 110,
            key: 'total_price',
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', [undefined, null, ''].includes(params.row.total_price) ? '-' : formattingNumber(params.row.total_price, 2)));
              return h('div', {
                style:{
                  margin: '0 10px 0 0'
                },
                'class': {
                  // 'text-center': true
                }
              }, ret);
            }
          },
          {
            title: '状态',
            minWidth: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  }
                })
              } else {
                return h('div', '-');
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 75,
            render: (h, params) => {
              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left'
                },
                on: {
                  'on-click': (event_name) => {
                    this.handleContractEvent(event_name, params.row, params.index);
                  }
                }
              }, [
                h('Button', [
                  h('span', ' 操作'),
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props:{name: 'edit'}
                  }, '编辑'),
                  h('DropdownItem', {
                    props:{name: 'payment'}
                  }, '申请付款'),
                  h('DropdownItem', {
                    props:{name: 'store-file'}
                  }, '归档'),
                  h('DropdownItem', {
                    props:{name: 'close'}
                  }, '完结'),
                  /*h('DropdownItem', {
                                        props:{name: 'print'}
                                    }, '打印'),
                                    h('DropdownItem', {
                                        props:{name: 'copy'}
                                    }, '复制一份'),
                                    h('DropdownItem', {
                                        props:{name: 'edit_desc'}
                                    }, '设置备注'),*/
                  h('DropdownItem', {
                    props:{name: 'delete', divided: true}
                  }, '废弃'),
                ])
              ]);
            }
          }
        ],
        edit_contract: {},
        // contract_types: [],
        // contract_type_hash: {},

        flow_nodes: [],

      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      select_teams() {
        const teams = [];
        teams.push({id: 0, name: '所有团队'});
        this.teams.forEach((team) => {
          teams.push(team);
        });
        return teams;
      },
      search_contract_type_result() {
        const ret = [];
        const search = this.search_contract_type_text;
        this.contract_types.forEach((type) => {
          if (search) {
            if (type.name.indexOf(search) > -1) {
              ret.push(type);
            }
          } else {
            ret.push(type);
          }
        });
        return ret;
      },
      ...mapGetters({
        contract_types_hash: 'async/contract_types_hash',
        contract_types: 'async/contract_types',
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      this.init();
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      init() {
        //  this.getContractTypes();
        this.getFlowInfo();
      },
      // getContractTypes() {
      //   Util.ajax.get(Util.api.get_contract_types).then((response) => {
      //     return response.data;
      //   }).then((res) => {
      //     if (res.code === 1) {
      //       const data = res.data;
      //       this.handleContractTypes(data);
      //     } else {
      //       this.$Modal.error({
      //         title: '错误',
      //         content: res.msg
      //       });
      //     }
      //   }).catch((e) => {
      //     console.log(e);
      //   });
      // },
      getFlowInfo() {
        Util.ajax.get(Util.api.get_flow_by_link_model, {
          params: {
            link_model: 'Contract'
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.nodes.forEach((node) => {
              this.flow_nodes.push(node);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      // handleContractTypes(contract_types) {
      //   contract_types.forEach((contract_type) => {
      //     /*if(contract_type.parent_id){
      //                   contract_type.name = this.contract_type_hash[contract_type.parent_id].name + '-' + contract_type.name;
      //               }*/
      //     this.contract_type_hash[contract_type.id] = contract_type;
      //     if (contract_type.contract_types.length) {
      //       contract_type.children = contract_type.contract_types;
      //       this.handleContractTypes(contract_type.contract_types);
      //     }
      //     this.contract_types.push(contract_type);
      //   });
      // },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        this.params.page = 1;
        this.$refs.searchBtn.doAjax();
      },
      handleContractData(data) {
        this.contracts = [];
        data.contracts.forEach((contract) => {
          this.contracts.push(contract);
        });
        if (data.contracts.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleContractFail(e) {
        this.$Modal.error({title: '错误', content: e.message});
      },
      handleContractFinally() {
        this.loading = false;
      },
      handleContractEvent(event_name, contract, index) {
        console.log(event_name);
        switch (event_name) {
        case 'edit':
          this.editContract(contract);
          break;
        case 'payment':
          this.editContractExpenseGroup(contract);
          break;
        case 'store-file':
          this.storeContractFile(contract);
          break;
        case 'close':
          this.closeContract(contract);
          break;
        case 'print':
          this.printContract(contract);
          break;
        case 'copy':
          this.copyContract(contract);
          break;
        case 'delete':
          this.deleteContract(contract);
          break;
        case 'edit_desc':
          this.editDesc(contract);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      closeContract(contract) {
        let content = `<p>${contract.uid} - ${contract.name}</p>`;
        content += `<p>你确定该合同已完结了吗?</p>`;
        this.$Modal.confirm({
          title: '将合同设置为完结状态',
          content: content,
          onOk: () => {
            Util.ajax.post(Util.api.close_contract, {
              id: contract.id,
              is_finish: true
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                contract.is_closed = true;
                this.$Message.success('设置成功!');
              } else {
                setTimeout(() => {
                  this.$Modal.error({title: '提示', content: res.msg});
                }, 600);
              }
            }).catch((e) => {
              setTimeout(() => {
                this.$Modal.error({title: '提示', content: e.message});
              }, 600);
            });
          }
        });
      },
      storeContractFile(contract) {
        this.$refs.editor.storeFile(contract);
      },
      editContract(contract) {
        this.$refs.editor.edit(contract);
      },
      printContract(contract) {
        this.$refs.printer.print(contract);
      },
      copyContract(contract) {
        const new_contract = Util.clone(contract);
        delete new_contract.id;
        delete new_contract.uid;
        new_contract.fill_user_id = this.cur_customer.id;
        new_contract.fill_user = this.cur_customer.account;
        new_contract.status = 0;
        new_contract.contracts.forEach((contract) => {
          delete contract.id;
        });
        this.editContract(new_contract);
      },
      deleteContract(contract) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要废弃 ' + contract.name + ' 吗?',
          onOk: () => {
            Util.ajax.post(Util.api.delete_contract, {
              id: contract.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                contract.del = true;
                this.$Message.success('删除成功!');
              } else {
                this.$Message.error(data.msg)
              }
            }).catch((e) => {
              console.log(e);
              this.$Message.error('删除失败' + e);
            });
          }
        })
      },
      getContractType(id) {
        return this.contract_type_hash[id] || {};
      },
      getContractTypeName(id) {
        return id ? this.contract_type_hash[id].name : '';
      },
      updateContract(contract) {
        if (contract.user_flow) {
          Util.insertOrUpdateArrayItem(this.contracts, contract, true);
        } else {
          this.doSearch();
        }
      },
      editContractExpenseGroup(contract) {
        const contract_id = contract.id || 0;
        localStorage.setItem('contract_id', contract_id);
        window.open('/mine/expense_group_company', '_blank');
      },
    }
  }
</script>
